module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "pviii"
    }
  }), _vm._v(" My vegetable love should grow")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "hang"
  }, [_vm._v("Vaster than empires and more slow . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "hang"
  }, [_vm._v("But at my back I always hear")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "hang"
  }, [_vm._v("Time’s winged chariot hurrying near . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "right"
  }, [_vm._v("—Andrew Marvell, “To His Coy Mistress”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d43ab752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front04.vue
// module id = 69
// module chunks = 0